// extracted by mini-css-extract-plugin
module.exports = {"Input":"AssignPartnerForm_Input__29ypq","DisableForm":"AssignPartnerForm_DisableForm__1tFdL"};